// extracted by mini-css-extract-plugin
export default {"mCard":"lB-z","image":"mB-z","imageNoBackground":"nB-z","fullWidth":"oB-z"};